'use client'
import React from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import SingleService from "@/components/home/single/SingleService";
import ThemeRow from "@/components/theme/row";

const ServiceListing = ({data}) => {


    return (
        <StyledComponent id={'services'} className={'pt-120 pb-120'}>
            <ThemeRow>
                {
                    data && data?.length > 0 &&
                    data?.map((e, index) => {
                        return (
                            <Col md={4} key={index}>
                                <SingleService
                                    nolink={e?.project_no_link}
                                    title={e?.post_title}
                                    icon={e?.project_logo}
                                    link={e?.post_name === 'property-solutions' ? '/projects' : `/service/${e?.post_name}`}
                                />
                            </Col>
                        )
                    })
                }
            </ThemeRow>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    background-image: url("/images/static/services_background.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    justify-content: center; /* Horizontally center the content */
    align-items: center; /* Vertically center the content */

    .col-md-4 {
        margin-bottom: 60px !important;
    }
`
export default React.memo(ServiceListing);